<template>
    <v-dialog
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
        persistent
        width="480"
    >
        <div class="partner-edit-dialog">
            <p class="partner-edit-dialog__title">Details incorrect?</p>

            <p class="partner-edit-dialog__body">
                This payment was initiated by a partner. To update your details,
                please restart the journey through the partner or contact them
                directly for assistance.
            </p>

            <text-button
                btn-style="default-btn default-btn__medium default-btn__full-width primary-btn align-item-center "
                text-style="white-text"
                text="Got it"
                aria-label="Got it"
                @run-method="$emit('update:modelValue', false)"
            />
        </div>
    </v-dialog>
</template>

<script setup lang="ts">
import textButton from "@/components/base/textButton.vue";

defineProps<{
    modelValue: boolean;
}>();

defineEmits<{
    "update:modelValue": [value: boolean];
}>();
</script>

<style scoped>
.partner-edit-dialog {
    background: var(--white);
    border-radius: var(--radius-container);
    padding: 18px 16px 18px;
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.partner-edit-dialog__title {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0;
}

.partner-edit-dialog__body {
    font-size: 15px;
    color: var(--text-secondary);
    line-height: 1.5;
    margin-bottom: 8px;
}
</style>
